import React from 'react';
import { PageFrame } from '../components/PageFrame';
import { aboutCards } from '../components/marketingContent';

type Props = {
  onPrimaryCta: () => void;
  onSecondaryCta: () => void;
};

export function AboutPage({ onPrimaryCta, onSecondaryCta }: Props) {
  return (
    <PageFrame title="About" onPrimaryCta={onPrimaryCta} onSecondaryCta={onSecondaryCta}>
      <section id="about" className="section">
        <div className="container">
          <div className="section-heading">
            <div>
              <h1 className="section-title">About</h1>
              <h2 className="section-subtitle">We turn SEC filings into pre-market clarity.</h2>
            </div>
            <p className="section-description">
              EDGAR Insights is a focused layer for desks that trade on fundamentals and events. We pair relentless
              ingestion with models trained on SEC language so you see what changed and why it matters, fast.
            </p>
          </div>
          <div className="about-grid">
            {aboutCards.map((card) => (
              <div className="about-card" key={card.title}>
                <h3>{card.title}</h3>
                <p>{card.copy}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </PageFrame>
  );
}
